import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasDocumentosLayoutsh2hDisponiblesLayoutConfirmar', {
    template: template,
    controller: NominasDocumentosLayoutsh2hDisponiblesLayoutConfirmarComponent,
    bindings: {
      idBanco: '<',
      idNomina: '<',
      idMoneda: '<',
      idProyecto: '<',
      interbancario: '<',
      masivo: '<',
      monedaCodigo: '<',
      monedaId: '<',
      nomina: '<',
      seleccionados: '<',
      dias: '<',
      total: '<',
      onClose: '&',
    },
  })

function NominasDocumentosLayoutsh2hDisponiblesLayoutConfirmarComponent ($file, $q, $zip, NominaOperadoraCuentasbancarias, NominaDocumentosLayoutsh2h, $filter, $jwt) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges
  $ctrl.aceptar = aceptar
  $ctrl.cancelar = cancelar
  $ctrl.cerrar = cerrar
  $ctrl.modificarTipoCambio = modificarTipoCambio
  $ctrl.totalizar = totalizar
  $ctrl.afectarTotal = false
  $ctrl.error = null
  $ctrl.archivo = null
  $ctrl.hoy = new Date()
  $ctrl.fechaPagoValidaciones = {
    fechapago: (value) => {
      let diaSemana = value.getDay()
      return $ctrl.dias.includes(diaSemana)
    },
  }
  $ctrl.idCuentaValidaciones = {
    codigocliente: (value) => !value || !!value.codigo_cliente,
  }
  $ctrl.tokenValidaciones = {
    expirado: (value) => !value || !$jwt.isExpired(value),
  }

  function $onInit () {
    $ctrl.fechaPago = $ctrl.nomina.fecha_pago
    $ctrl.tipoCambio = $ctrl.nomina.tipo_cambio
    $ctrl.fechaNomina = $ctrl.nomina.fecha_nomina

    $ctrl.incluyeDolares = $ctrl.seleccionados.some(function (item) {
      return item.id_moneda === 2
    })

    $ctrl.promise = NominaOperadoraCuentasbancarias.get($ctrl.idProyecto, $ctrl.idNomina, $ctrl.idBanco, $ctrl.idMoneda)
      .then(function (response) {
        $ctrl.cuentasBancarias = $filter('orderBy')(response.data, ['moneda', 'banco', 'cuenta'])

        $ctrl.cuentaBancaria = $ctrl.cuentasBancarias.find(function (item) {
          return item.predeterminado
        })
      })
  }

  function $onChanges (changes) {
    if (changes.seleccionados) {
      $ctrl.seleccionados = angular.copy($ctrl.seleccionados)

      $ctrl.tipoCambioVariable = $ctrl.seleccionados.reduce(function (tipoCambio, pago) {
        if (tipoCambio === null || pago.id_moneda === 1)
          return tipoCambio

        if (pago.tipo_cambio !== tipoCambio)
          tipoCambio = null

        return tipoCambio
      }, 0)

      $ctrl.totalizar()
    }
  }

  function aceptar () {
    if($ctrl.generando) return 
    
    $ctrl.generando = true
    $ctrl.error = null

    NominaDocumentosLayoutsh2h.post($ctrl.idProyecto, $ctrl.idNomina, $ctrl.cuentaBancaria.id_banco, $ctrl.cuentaBancaria.id_cuenta, $ctrl.cuentaBancaria.id_moneda, $ctrl.cuentaBancaria.codigo_cliente, $ctrl.tipoCambio, $ctrl.fechaPago, $ctrl.pin, $ctrl.token, $ctrl.seleccionados, $ctrl.total, $ctrl.interbancario, $ctrl.masivo, $ctrl.monedaId)
      .then(function (response) {
        $ctrl.archivo = response.data.filename
        $ctrl.data = response.data.layoutData
      })
      .catch(function (response) {
        $ctrl.error = (response && response.data) || 'Se ha generado un error'
      })
      .finally(function () {
        $ctrl.generando = false
      })
  }

  function cancelar () {
    $ctrl.onClose()
  }

  function cerrar () {
    $ctrl.onClose({$event: {data: $ctrl.data}})
  }

  /*function modificarTipoCambio () {
    $ctrl.seleccionados
      .filter(function (item) {
        return item.id_moneda === 2
      })
      .forEach(function (item) {
        item.tipo_cambio = $ctrl.tipoCambio
      })

    totalizar()
  }*/

  function modificarTipoCambio () {
    $ctrl.afectarTotal = true
    $ctrl.totalizar()
  }

  function totalizar () {
    $ctrl.total = $ctrl.seleccionados
      .reduce(function (total, item) {
        return total + (item.importe / ($ctrl.afectarTotal ? $ctrl.tipoCambio : item.tipo_cambio))
      }, 0)

    $ctrl.afectarTotal = false
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/layoutsh2h/disponibles/layout/confirmar/component.js